/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { BulkManageSchedule_CustomerFragmentDoc } from '../BulkAction/__generated__/BulkManageSchedule.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ManageScheduleModal_CustomerFragment = { __typename: 'Customer', id: string, schedules: Array<{ __typename: 'Schedule', id: string, title: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', type: Types.TimeBlockType, data: { __typename: 'ScheduleTimeBlockData', mediaType?: string | null } }> }> };

export type ManageScheduleModal_DisplayFragment = { __typename: 'Display', id: string, playlistType?: Types.PlaylistType | null, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', id: string, title: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day }> } | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string } | { __typename: 'ScheduleUpdateCompleted', id: string } | { __typename: 'ScheduleUpdateInProgress', id: string } | { __typename: 'ScheduleUpdateRejected', id: string } | null } | null };

export type DisplayUpdateScheduleMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateScheduleInput;
}>;


export type DisplayUpdateScheduleMutation = { __typename: 'Mutation', displayBulkUpdateSchedule: { __typename: 'DisplayBulkUpdateSchedulePayload', displays: Array<{ __typename: 'Display', id: string, playlistType?: Types.PlaylistType | null, schedule?: { __typename: 'DisplaySchedule', schedule?: { __typename: 'Schedule', id: string, title: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day }> } | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string } | { __typename: 'ScheduleUpdateCompleted', id: string } | { __typename: 'ScheduleUpdateInProgress', id: string } | { __typename: 'ScheduleUpdateRejected', id: string } | null } | null }> } };

export const ManageScheduleModal_CustomerFragmentDoc = gql`
    fragment ManageScheduleModal_customer on Customer {
  id
  ...BulkManageSchedule_customer
}
    ${BulkManageSchedule_CustomerFragmentDoc}`;
export const ManageScheduleModal_DisplayFragmentDoc = gql`
    fragment ManageScheduleModal_display on Display {
  id
  playlistType
  schedule {
    schedule {
      id
      title
      timeBlocks {
        start
        end
        day
      }
    }
    latestJob {
      id
      __typename
    }
  }
}
    `;
export const DisplayUpdateScheduleDocument = gql`
    mutation DisplayUpdateSchedule($input: DisplayBulkUpdateScheduleInput!) {
  displayBulkUpdateSchedule(input: $input) {
    displays {
      id
      ...ManageScheduleModal_display
    }
  }
}
    ${ManageScheduleModal_DisplayFragmentDoc}`;
export type DisplayUpdateScheduleMutationFn = ApolloReactCommon.MutationFunction<DisplayUpdateScheduleMutation, DisplayUpdateScheduleMutationVariables>;

/**
 * __useDisplayUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useDisplayUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayUpdateScheduleMutation, { data, loading, error }] = useDisplayUpdateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisplayUpdateScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisplayUpdateScheduleMutation, DisplayUpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisplayUpdateScheduleMutation, DisplayUpdateScheduleMutationVariables>(DisplayUpdateScheduleDocument, options);
      }
export type DisplayUpdateScheduleMutationHookResult = ReturnType<typeof useDisplayUpdateScheduleMutation>;
export type DisplayUpdateScheduleMutationResult = ApolloReactCommon.MutationResult<DisplayUpdateScheduleMutation>;
export type DisplayUpdateScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<DisplayUpdateScheduleMutation, DisplayUpdateScheduleMutationVariables>;